var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-no-wrap"},[_vm._t("clockIn",[_vm._v("\n    "+_vm._s(_vm.getClockInTime(_vm.item))+"\n  ")],{"item":_vm.item})],2)}
var staticRenderFns = []

export { render, staticRenderFns }